import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSignOut = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SignOut</title>
    <path
      d="M11.999 6.128H7.428a2.286 2.286 0 0 0-2.286 2.286v17.142a2.286 2.286 0 0 0 2.286 2.286h4.57m0-10.857h16m0 0-6.857 6.857m6.857-6.857-6.857-6.857"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSignOut;
